import moment from "moment-timezone";
import { getLogger } from "./logging";

// This could be a nice class, maybe.

const { log, warn } = getLogger('Dates', { color: 'red', enabled: false });

export const DEFAULT_TIMEZONE = process.env.DEFAULT_TIMEZONE || "America/New_York";
export const DATE_FORMAT = "YYYY-MM-DD";
export const FULL_DATE_FORMAT = "YYYY-MM-DD hh:mm:ss a";
export const SHORT_DATE_FORMAT = "MMM Do h:mma";
export const HOURLY_FORMAT = "-ha";
export const MIN_DATE = -8640000000000000; // used for comparing times

export const formatIsoShort = (date) => {
    if (!date) return '';
    try {
        let str = date.toISOString(); "2013-03-01T00:00:00+01:00"
        let strParts = str.split('T');
        let day = strParts[0].split('-'), hour = strParts[1].split(':');
        if (day[1][0] == '0') day[1] = day[1][1]; // remove leading 0
        if (hour[0][0] == '0') hour[0] = hour[0][1]; // remove leading 0
        return `${day[1]}/${day[2]}/${day[0][2]}${day[0][3]} ${hour[0]}:${hour[1]}`;
    } catch (e) {
        console.log(`Exception in formatIsoShort, date:`, date)
        return date.toISOString();
    }
}

const DAY_OFFSET = 0;

window.moment = moment;
let timezone = moment.tz.guess(); // start as default
window.timezone = timezone;

// not really used but here if needed
export const setGlobalTimezone = (_timezone) => {
    window.timezone = timezone = _timezone || DEFAULT_TIMEZONE;
}
export const getGlobalTimezone = () => {
    return timezone || DEFAULT_TIMEZONE;
}

export enum DateRange {
    Week = 0,
    Today = 1,
    Yesterday = 2
}


export const printTime = (date) => {
    if (date) {
        console.log('printTime', date)
        return date.format(FULL_DATE_FORMAT);
    }
}

export const printDates = (dates) => {
    //console.log('New dates, timezone:', timezone);
    Object.keys(dates).forEach(k => {
        let d = dates[k];
        console.log('Date: ', k, ' = ', typeof d == 'function' ? d() : (Array.isArray(d) ? (d[0].format(FULL_DATE_FORMAT) + ' to ' + d[1].format(FULL_DATE_FORMAT)) : d.format(FULL_DATE_FORMAT)));
    });
}

// keeps tracking of actual current dates, recalculated upon calling recalculate_core_dates(), ie. during app refreshes.
let currentDates: any = {}
export const recalculate_core_dates = (_timezone?) => {
    log('⌚ recalculate_core_dates, timezone:', _timezone);

    if (!_timezone) {
        _timezone = moment.tz.guess();
        log('Warning: timezone not given (not found in store?), using default:', _timezone)
    }

    // helper function to get 'now' relative to store time.
    currentDates.tzNow = (tz?) => moment.tz(moment(), (tz || _timezone || timezone)); //moment().tz(_timezone);
    // helper function to create new moment object from datestring, but in the store timezone
    currentDates.tz = (dateString: string, tz?) => moment.tz(dateString, (tz || _timezone || timezone));

    currentDates.today = moment.tz(_timezone);
    currentDates.tomorrow = moment(currentDates.today).set('date', currentDates.today.get('date') + 1);
    currentDates.yesterday = moment.tz(_timezone).subtract(1, 'days');
    currentDates.last3days = moment.tz(_timezone).subtract(3, 'days');
    currentDates.last7days = moment.tz(_timezone).subtract(7, 'days');
    currentDates.next7days = moment.tz(_timezone).add(7, 'days');
    currentDates.last14days = moment.tz(_timezone).subtract(14, 'days');
    currentDates.last30days = moment.tz(_timezone).subtract(30, 'days');
    currentDates.next30days = moment.tz(_timezone).add(30, 'days');
    currentDates.sevendays = moment(currentDates.today).set('date', currentDates.today.get('date') - 7);
    currentDates.thirtydays = moment(currentDates.today).set('date', currentDates.today.get('date') - 30);

    currentDates.thisMonth = [
        moment.tz(_timezone).startOf('month').startOf('day'),
        moment.tz(_timezone).endOf('month').endOf('day')
    ];

    currentDates.lastMonth = [
        moment.tz(_timezone).subtract(1, 'months').startOf('month').startOf('day'),
        moment.tz(_timezone).subtract(1, 'months').endOf('month').endOf('day')
    ];

    currentDates.twoMonths = [
        moment.tz(_timezone).subtract(2, 'months').startOf('month').startOf('day'),
        moment.tz(_timezone).subtract(2, 'months').endOf('month').endOf('day')
    ];

    currentDates.thisMonthLastYear = [
        moment.tz(_timezone).subtract(1, 'year').startOf('month').startOf('day'),
        moment.tz(_timezone).subtract(1, 'year').endOf('month').endOf('day')
    ];

    currentDates.previousMonthLastYear = [
        moment.tz(_timezone).subtract(1, 'year').subtract(1, 'month').startOf('month').startOf('day'),
        moment.tz(_timezone).subtract(1, 'year').subtract(1, 'month').endOf('month').endOf('day'),
    ];

    currentDates.previous7 = [
        currentDates.last14days.clone().startOf('day'),
        currentDates.last7days.clone().subtract(1, 'day').endOf('day')
    ];

    currentDates.last3 = [
        currentDates.last3days.clone().startOf('day'),
        currentDates.yesterday.clone().endOf('day')
    ];

    currentDates.last7 = [
        currentDates.last7days.clone().startOf('day'),
        currentDates.yesterday.clone().endOf('day')
    ];

    currentDates.next7 = [
        currentDates.today.clone().startOf('day'),
        currentDates.next7days.clone().endOf('day')
    ];

    currentDates.last30 = [
        currentDates.last30days.clone().startOf('day'),
        currentDates.yesterday.clone().endOf('day')
    ];

    currentDates.next30 = [
        currentDates.today.clone().startOf('day'),
        currentDates.next30days.clone().endOf('day')
    ];

    // 7 day sample of last month
    currentDates.lastMonthLast7 = [
        currentDates.today.clone().subtract(1, 'months').subtract(7, 'days').startOf('day'),
        currentDates.today.clone().subtract(1, 'months').subtract(1, 'days').endOf('day')
    ];

    // 7 day sample of last month
    currentDates.lastYearLast7 = [
        currentDates.today.clone().subtract(1, 'years').subtract(1, 'months').subtract(7, 'days').startOf('day'),
        currentDates.today.clone().subtract(1, 'years').subtract(1, 'months').subtract(1, 'days').endOf('day')
    ];


    //console.log('New app dates calculated for timezone:', _timezone, 'Now in timezone:', currentDates.tzNow().format(FULL_DATE_FORMAT), 'Now local:', moment().format(FULL_DATE_FORMAT));
    //printDates(currentDates);
}

// initialize date objects with default timezone
recalculate_core_dates();

let cloner = (m) => m.clone();

export const now = (tz?) => currentDates.tzNow(tz).clone();
export const tzNow = now; //alias
export const nowStore = now; //naming convenience, maybe it's clearer.

// return the current global/account timezone, or default
export const getTimezone = () => {
    return timezone || DEFAULT_TIMEZONE;
}

// returns a moment Date for the given short date, with the timezone set to the store correctly.
export const getStoreDate = (date, tz?) => {
    return moment.tz(date.format(DATE_FORMAT), DATE_FORMAT, (tz || timezone));
}

// returns a date in the current/account's timezone (can be overriden in second argument)
// bit of alternative to the above. TODO: clean.
export const tzDate = (dateString: string, tz?: string) => {
    return moment.tz(dateString, (tz || timezone));
}

// todo: fix these...
export const today = (tz?) => getStoreDate(currentDates.today.clone(), tz);
export const todayStart = (tz?) => currentDates.tzNow(tz).clone().startOf('day');
export const todayEnd = (tz?) => currentDates.tzNow(tz).clone().endOf('day');
export const tomorrow = (tz?) => getStoreDate(currentDates.tomorrow.clone(), tz);
export const yesterday = (tz?) => getStoreDate(currentDates.yesterday.clone(), tz);
export const yesterdayStart = (tz?) => getStoreDate(currentDates.yesterday.clone(), tz).startOf('day');
export const yesterdayEnd = (tz?) => getStoreDate(currentDates.yesterday.clone(), tz).endOf('day');
export const last3days = () => currentDates.last3days.clone();
export const last7days = () => currentDates.last7days.clone();
export const last14days = () => currentDates.last14days.clone();
export const last30days = () => currentDates.last30days.clone();
export const sevendays = () => currentDates.sevendays.clone();
export const thirtydays = () => currentDates.thirtydays.clone();
export const thisMonth = () => currentDates.thisMonth.map(cloner);
export const thisMonthSoFar = (backOneDay = false) => {
    let tm = [currentDates.thisMonth[0].clone().startOf('day'), todayEnd()];
    if (backOneDay) tm[1].subtract(1, 'day');
    if (tm[1].isBefore(tm[0])) tm[1].add(1, 'day'); // ensure range is still valid
    return tm;
}
export const previous7 = () => currentDates.previous7.map(cloner);
export const last3 = () => currentDates.last3.map(cloner);
export const last7 = () => currentDates.last7.map(cloner);
export const next7 = () => currentDates.next7.map(cloner);
export const last30 = () => currentDates.last30.map(cloner);
export const next30 = () => currentDates.next30.map(cloner);
export const lastMonth = () => currentDates.lastMonth.map(cloner);
export const lastMonthLast7 = () => currentDates.lastMonthLast7.map(cloner);
export const twoMonths = () => currentDates.twoMonths.map(cloner);
export const thisMonthLastYear = () => currentDates.thisMonthLastYear.map(cloner);
export const previousMonthLastYear = () => currentDates.previousMonthLastYear.map(cloner);
export const lastYearLast7 = () => currentDates.lastYearLast7.map(cloner);
export const startOfMonth = (tz?) => now(tz).startOf('month');
export const startOfQuarter = (tz?) => now(tz).startOf('quarter');
export const startOfYear = (tz?) => now(tz).startOf('year');

////////////////////////////////////////////////////////

// UTILITY METHODS:

export const isDateToday = (dateStr, tz?) => {
    let tzd = tzDate(dateStr, tz);
    let tzn = today();
    return tzd.format(DATE_FORMAT) === tzn.format(DATE_FORMAT);
}

export const thisMonthSoFarLength = (tz?) => todayStart(tz).diff(todayStart(tz).startOf('month'), 'days') + 1;

export const daysInThisMonth = (tz?) => today(tz).daysInMonth();

// Stuff to clean: ///////////////////////////

// returns array of days, by default of the current month (+1)
export const DAYS = (daysBack) => {
    const days = [];
    let dateStart = moment(currentDates.today).startOf('month');
    let dateEnd = moment(currentDates.today).endOf('month').add(1, 'days');

    if (daysBack !== null && daysBack !== 0) {
        dateStart = moment(currentDates.today).subtract(daysBack, 'days').startOf('month');
        dateEnd = moment(currentDates.today).subtract(daysBack, 'days').endOf('month').add(1, 'days');
    }

    while (dateEnd.diff(dateStart, 'days') >= 1) {
        days.push(dateStart.format('D'));
        dateStart.add(1, 'days');
    }

    return days;
};

// export const getDateFromMysql = (isoDateStr: string): Date => {
//     var dateParts = isoDateStr.split("-");
//     return new Date(dateParts[0], dateParts[1] - 1, dateParts[2].substr(0,2));
// }

// export const getMysqlDate = (date?: Date): string => {
//     let d = date || new Date();
//     return d.toISOString().slice(0, 19).replace('T', ' ');
// }

// return a { start_date, end_date } object with the UTC/ISO strings.
// TODO: integrate timezone...
export const createIsoTimeRange = (value, tz?, returnArray = false) => {
    let n, start, end, hour;

    let timeRange = { start_date: undefined, end_date: undefined }
    switch (value) {

        case 'all':
            timeRange = { start_date: undefined, end_date: undefined }
            break;

        case 'thisHour':
            n = now(tz);
            hour = n.get('hour');
            start = n.set.set('hour', hour).set('minute', 0).set('second', 0).set('millisecond', 0);
            end = n.clone().set('hour', hour + 1).set('minute', 0).set('second', 0).set('millisecond', 0);
            timeRange = { start_date: start, end_date: end };
            break;

        case 'lastHour':
            n = now(tz);
            hour = n.get('hour');
            start = n.set('hour', hour - 1).set('minute', 0).set('second', 0).set('millisecond', 0);
            end = n.clone().set('hour', hour).set('minute', 0).set('second', 0).set('millisecond', 0);
            timeRange = { start_date: start, end_date: end }
            break

        case 'today':
            //console.log('creating TODAY', today(), today().format(FULL_DATE_FORMAT), today().startOf('day').toISOString());
            timeRange = { start_date: today(tz).startOf('day'), end_date: today(tz).endOf('day') }
            break;

        case 'yesterday':
            timeRange = { start_date: yesterday(tz).startOf('day'), end_date: yesterday(tz).endOf('day') }
            break;

        case 'last3days':
            let _last3 = last3();
            timeRange = { start_date: _last3[0], end_date: _last3[1] }
            break;

        case 'last7days':
            let _last7 = last7();
            timeRange = { start_date: _last7[0], end_date: _last7[1] }
            break;

        case 'next7days':
            let _next7 = next7();
            timeRange = { start_date: _next7[0], end_date: _next7[1] }
            break;

        // from yesterdy back 30 days
        case 'last30days':
            let _last30 = last30();
            timeRange = { start_date: _last30[0], end_date: _last30[1] }
            break;

        // from today forward 30 days
        case 'next30days':
            let _next30 = next30();
            timeRange = { start_date: _next30[0], end_date: _next30[1] }
            break;

        case 'previous7days':
            let _previous7 = previous7();
            timeRange = { start_date: _previous7[0], end_date: _previous7[1] }
            break;

        case 'thisMonth':
            let _thisMonth = thisMonth();
            timeRange = { start_date: _thisMonth[0], end_date: _thisMonth[1] }
            break;

        case 'thisMonthSoFar':
            let _thisMonthSoFar = thisMonthSoFar();
            timeRange = { start_date: _thisMonthSoFar[0], end_date: _thisMonthSoFar[1] }
            break;

        case 'lastMonth':
            let _lastMonth = lastMonth();
            timeRange = { start_date: _lastMonth[0], end_date: _lastMonth[1] }
            break;

        // 7-day sample from (now - 1month - 8 days) to (now - 1month - 1 day)
        case 'lastMonthLast7':
            let _lastMonthLast7 = lastMonthLast7();
            timeRange = { start_date: _lastMonthLast7[0], end_date: _lastMonthLast7[1] }
            break;

        case 'twoMonths':
            let _twoMonths = twoMonths();
            timeRange = { start_date: _twoMonths[0], end_date: _twoMonths[1] }
            break;

        case 'thisMonthLastYear':
            let _thisMonthLastYear = thisMonthLastYear();
            timeRange = { start_date: _thisMonthLastYear[0], end_date: _thisMonthLastYear[1] }
            break;

        // 7-day sample from (now - 1 year - 8 days) to (now - 1 year - 1day)
        case 'lastYearLast7':
            let _lastYearLast7 = lastYearLast7();
            timeRange = { start_date: _lastYearLast7[0], end_date: _lastYearLast7[1] };
            break;

        case 'previousMonthLastYear':
            let _previousMonthLastYear = previousMonthLastYear();
            timeRange = { start_date: _previousMonthLastYear[0], end_date: _previousMonthLastYear[1] }
            break;

        // constructs a date range from (beginning of this month) to (today)
        case 'mtd':
        case 'MTD':
        case 'monthToDate':
            timeRange = { start_date: startOfMonth(tz), end_date: todayEnd(tz) }
            break;

        // constructs a date range from (beginning of this quarter) to (today)
        case 'qtd':
        case 'QTD':
        case 'quarterToDate':
            timeRange = { start_date: startOfQuarter(tz), end_date: todayEnd(tz) }
            break;

        // constructs a date range from (beginning of this year) to (today)
        case 'ytd':
        case 'YTD':
        case 'yearToDate':
            timeRange = { start_date: startOfYear(tz), end_date: todayEnd(tz) }
            break;

        default:
            throw "Time range is not supported: " + value;
    }

    return returnArray ?
        [timeRange.start_date, timeRange.end_date] :
        ({
            start_date: timeRange.start_date.toISOString(),
            end_date: timeRange.end_date.toISOString()
        })
}

// returns a string array of dayes. new version of mapDaysBetweenDates, but takes a string range.
export function daysFromTimeRange(range, includeLast = true, _timezone?) {
    _timezone = _timezone || DEFAULT_TIMEZONE;
    let timeRange = createIsoTimeRange(range, timezone);
    return mapDaysBetweenDates(timeRange.start_date, timeRange.end_date, includeLast, timezone);
}

// just ensures the array is 7 items long, removing end/extra items if necessary.
export const ensure7Days = (array) => {
    // remove beginning items if > 7, as dates and data sometimes are incomplete:
    if (array.length > 7) {
        array.splice(0, array.length - 7);
    }
    // while (array.length > 7) {
    //     array.shift()
    // }
    return array;
}


// Return array of daily dates (YYYY-MM-DD) including _from, up to but NOT including _to (unless includeLast == true).
// If _from and _to are same day, returns array with that single day.
// _from and _to can short or long iso format, it will still resolve to correct timezone days.
export function mapDaysBetweenDates(_from, _to, includeLast = false, _timezone?) {
    _timezone = _timezone || DEFAULT_TIMEZONE;
    const from = moment.tz(_from, _timezone);
    const to = moment.tz(_to, _timezone);

    // validate legal range
    if (!from.isBefore(to)) throw `The "from" date must be earlier than or equal to the "to" date, from: ${_from} to: ${_to}.`;

    // return just one day if the same
    if (from.format(DATE_FORMAT) == to.format(DATE_FORMAT)) return [from.format(DATE_FORMAT)];

    let current = from.clone();
    const days = [];
    while (current.isBefore(to)) {
        days.push(current.format(DATE_FORMAT));
        current.add(1, 'days');
    }

    if (includeLast) days.push(current.format(DATE_FORMAT));

    //console.log(`mapDaysBetweenDates`, _from, _to, `= ${days.length} days. last: ${days[days.length-1]}`)
    return days;
}

// Returns number of days between two dates.
export const dayDiff = (date1, date2) => Math.ceil(Math.abs(date1.getTime() - date2.getTime()) / 86400000);

// Validates that a string is in format of 'YYYY-MM'
export const validateMonthString = (month: string): boolean => {
    return /^\d{4}-(0\d|(0|1|2))$/g.test(month);
}

// Returns a printable duration string, ie. '2 hours, 3 minutes, 4 seconds'.
export const getDurationString = (startTime, endTime, format = 'short': 'long' | 'short') => {
    // var startTime=moment("12:16:59 am", "HH:mm:ss a");
    // var endTime=moment("06:12:07 pm", "HH:mm:ss a");
    let duration = moment.duration(endTime.diff(startTime));
    let hours = parseInt(duration.asHours());
    let minutes = parseInt(duration.asMinutes()) - hours * 60;
    let seconds = parseInt(duration.asSeconds()) - (hours * 60 * 60) - (minutes * 60);
    let r = {
        hours: endTime.diff(startTime, 'hours'),
        minutes: endTime.diff(startTime, 'minutes'),
        seconds: endTime.diff(startTime, 'seconds')
    }
    let str = '';
    if (hours > 0) {
        str += `${hours}${format == long ? ` hours` : `hrs`}`;
        delim = ', ';
    }
    if (minutes > 0) {
        str += `${delim}${minutes}${format == long ? ` minutes` : `mins`}`;
        delim = ', ';
    }
    if (seconds > 0) {
        str += `${delim}${seconds}${format == long ? ` seconds` : `secs`}`;
    }
    return str;
}

// Use: dayDiff(new Date("2020-10-21"), new Date("2021-10-22"))


// window.datetest = () => {
//     console.log('moment now (local):', moment().format(FULL_DATE_FORMAT));

//     let start = moment();
//     let end = moment().set('date', start.get('date') + 1);

//     console.log('moment today local date:', start.format(FULL_DATE_FORMAT));
//     console.log('moment tomorrow local date:', end.format(FULL_DATE_FORMAT));

//     start.set('hour', 0);
//     start.set('minute', 0);
//     start.set('second', 0);
//     start.set('millisecond', 0);
//     end.set('hour', 0);
//     end.set('minute', 0);
//     end.set('second', 0);
//     end.set('millisecond', 0);

//     console.log('moment today (start) local date:', start.format(FULL_DATE_FORMAT))
//     console.log('moment tomorrow (end) local date:', end.format(FULL_DATE_FORMAT))

//     // EST:


//     console.log('today() is currently set as:', today().format(FULL_DATE_FORMAT))

//     start = getESTDate(today());
//     end = getESTDate(tomorrow());

//     console.log('moment now (EST):', moment().tz(DEFAULT_TIMEZONE).format(FULL_DATE_FORMAT));

//     console.log('moment today EST date:', start.format(FULL_DATE_FORMAT))
//     console.log('moment tomorrow EST date:', end.format(FULL_DATE_FORMAT))

//     start.set('hour', 0);
//     start.set('minute', 0);
//     start.set('second', 0);
//     start.set('millisecond', 0);
//     end.set('hour', 0);
//     end.set('minute', 0);
//     end.set('second', 0);
//     end.set('millisecond', 0);

//     console.log('moment today (start) EST date:', start.format(FULL_DATE_FORMAT))
//     console.log('moment tomorrow (end) EST date:', end.format(FULL_DATE_FORMAT))
// }
// // check dates initially:
// window.datetest()

// --------------------------------------------------------------------------------
